/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlockedDaysOfYearDto } from '../../models/blocked-days-of-year-dto';
import { CreatePublicHolidaysForm } from '../../models/create-public-holidays-form';

export interface CreatePublicHolidays$Params {
      body: CreatePublicHolidaysForm
}

export function createPublicHolidays(http: HttpClient, rootUrl: string, params: CreatePublicHolidays$Params, context?: HttpContext): Observable<StrictHttpResponse<BlockedDaysOfYearDto>> {
  const rb = new RequestBuilder(rootUrl, createPublicHolidays.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BlockedDaysOfYearDto>;
    })
  );
}

createPublicHolidays.PATH = '/blocked-days/public-holidays';
